import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, Lock } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import { adminApi, formatApiError } from "@/lib/adminApi";
import { useNoIndex } from "@/lib/useNoIndex";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useNoIndex();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await adminApi.post("/auth/login", { email, password });
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err?.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const input = "w-full rounded-2xl border border-slate-200 bg-white px-4 py-3.5 text-base text-ink outline-none transition-colors focus:border-sky-600";

  return (
    <div className="sky-wash flex min-h-screen items-center justify-center px-5" data-testid="admin-login-page">
      <motion.form
        onSubmit={submit}
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="w-full max-w-md rounded-[32px] bg-white/90 p-8 shadow-[0_40px_100px_-60px_rgba(11,79,138,0.6)] backdrop-blur-xl sm:p-10"
        data-testid="admin-login-form"
      >
        <a href="/" data-testid="admin-login-home-link"><Logo /></a>
        <p className="mt-10 font-mono text-xs uppercase tracking-[0.25em] text-sky-700">Team access</p>
        <h1 className="mt-3 font-display text-3xl font-semibold tracking-tight text-ink">Enquiries dashboard</h1>
        <div className="mt-8 space-y-4">
          <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={input} data-testid="admin-login-email" />
          <input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={input} data-testid="admin-login-password" />
        </div>
        {error && <p className="mt-4 text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-ink px-6 py-4 text-sm font-medium text-white transition-colors hover:bg-sky-700 disabled:opacity-60" data-testid="admin-login-submit">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />}
          Sign in
        </button>
      </motion.form>
    </div>
  );
}
